import React from 'react';
import Work_1 from '../../../assets/images/home_page_6/work/01.png';
import Work_2 from '../../../assets/images/home_page_6/work/02.png';
import Work_3 from '../../../assets/images/home_page_6/work/03.png';

const workItems = [
    { id: 1, title: "Unlock Your Digital Possibilities", img: Work_1, bgClass: "bg_light_blue", imgBgClass: "bg_blue" },
    { id: 2, title: "Achieve Digital Brilliance", img: Work_2, bgClass: "bg_light_orange", imgBgClass: "bg_orange" },
    { id: 3, title: "Ignite Your Digital Passion", img: Work_3, bgClass: "bg_light_red", imgBgClass: "bg_red" },
];

const Work = () => {
    return (
        <section id="work" className="work-main-block">
            <div className="container">
                <div className="section text-center">
                    <h3 className="section-heading">Let’s see how we work</h3>
                    <p>
                        For your car, we will do everything—advice, repairs, and maintenance. We
                        are the preferred choice by many car owners because our experience
                        and knowledge are self-evident.
                    </p>
                </div>
                <div className="row">
                    {workItems.map((work) => (
                        <div key={work.id} className="col-lg-4 col-md-4">
                            <div className={`work-block text-center ${work.bgClass}`}>
                                <h5 className="work-title">{work.title}</h5>
                                <div className={`work-img ${work.imgBgClass}`}>
                                    <img src={work.img} className="img-fluid" alt={work.title} />
                                    <span className="badge text-bg-primary">{`0${work.id}`}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Work;
